export default {
    'baseURL': 'https://www.dzwonek.pl/',
}
